<template>
  <caption-header-skeleton v-if="status === 'loading'" :has-back="hasBack" :right-section-type="rightSection.type" :has-subtitle="hasSubtitle" />
  <template v-else>
    <div class="szw-row szw-rounded-lg szw-w-full szw-bg-color-primary szw-text-white szw-h-14 szw-min-h-14">
      <div class="szw-row szw-p-2 szw-w-full szw-max-w-[768px] szw-bg-transparent szw-overflow-hidden szw-h-full szw-mx-auto">
        <!-- BACK ICON -->
        <div v-if="hasBack" @click="backFn" class="szw-row__center szw-h-6 szw-w-6 szw-cursor-pointer" e2e-id="szw-caption-header-back-button">
          <sprite sprite-id="arrow-back" color="#ffffff" />
        </div>

        <!-- TEXT -->
        <div :class="[`szw-col${hasBack ? '__center' : ''} szw-overflow-hidden`, {' szw-gap-[4px]': subtitle }]" :style="{ width: `calc(100% - ${textOffset}px)` }" >
          <!-- CAPTION TITLE -->
          <szw-text :text="title" :align="hasBack ? 'center' : ''" classes="szw-font-semibold szw-text-base szw-leading-[17px]" e2e-id="szw-caption-title" key="title" />
          <!-- CAPTION SUBTITLE -->
          <szw-text :text="`${subtitle}`" :classes="`szw-tracking-wider szw-uppercase szw-text-xxs${hasBack ? ' szw-mx-auto' : ''}`" e2e-id="szw-caption-subtitle" key="subtitle" />
        </div>

        <!-- ICON | LOGO -->
        <template v-if="rightSection.type !== 'none'">
          <div class="szw-ml-auto szw-w-[32px] szw-h-[32px] szw-flex szw-items-center szw-justify-center" @click="handleRightSectionClick" data-test="right-section-logo">
            <sprite v-if="rightSection.type === 'icon'" :sprite-id="rightSection.src" :color="rightSection.config?.color || 'white'" class="szw-cursor-pointer" />

            <img v-if="rightSection.type === 'logo' && rightSection.src" :class="['szw-ml-auto', rightSection.config?.classes]" :src="rightSection.src" alt="logo" />
            <fallback-logo v-if="fallbackLogoConfig.isVisible" :text="fallbackLogoConfig.text" size="full" class="szw-text-white"/>
          </div>
        </template>
      </div>
    </div>
  </template>
</template>

<script setup>
import { inject, computed } from 'vue'
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import SzwText from '@/__core__/components/typography/text/Text.vue'
import CaptionHeaderSkeleton from './CaptionHeaderSkeleton.vue'
import FallbackLogo from '@/__core__/components/FallbackLogo.vue'

/** @type {{ rightSection: { type: '' | 'icon' | 'logo' } }} */
const props = defineProps({
  title: {
    type: String,
    default: () => ''
  },
  subtitle: {
    type: String,
    default: () => ''
  },
  hasBack: {
    type: Boolean,
    default: () => false
  },
  rightSection: {
    type: Object,
    default: () => ({ type: 'none', src: '', config: {} })
  },
  hasSubtitle: {
    type: Boolean,
    default: true
  }
})

const status = inject('status')

const emit = defineEmits(['back', 'right-section-click'])

const fallbackLogoConfig = computed(() => {
  const config = props.rightSection.config || {}
  const src = props.rightSection.src

  return {
    isVisible: !src && (config.fallbackLogoText || props.subtitle),
    text: config.fallbackLogoText || props.subtitle
  }
})

const textOffset = computed(() => {
  const rightOffset = props.rightSection.type !== 'none' ? 40 : 0
  const leftOffset = props.hasBack ? 48 : 0
  return rightOffset + leftOffset
})

const backFn = () => {
  emit('back')
}

const handleRightSectionClick = () => {
  emit('right-section-click')
}
</script>
